import { colors as akColors } from '@atlaskit/theme';
import { getTokenValue } from '@atlaskit/tokens';
import type { BurnupChartData } from '../../../common/types';
import { type SprintEvent, getCompletion } from '../../../common/utils/sprint-event';

type Series = [string, number][];

export const shouldRenderTodayLine = (burnup: BurnupChartData, now: Date, maxDate: Date): boolean =>
	burnup.sprintEndEvent == null && now.getTime() < maxDate.getTime();

const createSeries = (series: Series, point: SprintEvent): Series => {
	if (series.length) {
		const lastPoint = series[series.length - 1];
		const lastValue = lastPoint[1];
		series.push([point.data.timestamp, lastValue]);
	}

	series.push([point.data.timestamp, getCompletion(point)]);
	return series;
};

const getCompletedWorkSeries = (
	burnup: BurnupChartData,
	sprintEvents: SprintEvent[],
	now: Date,
	maxDate: Date,
) => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const data: Series = sprintEvents.reduce<Array<any>>(createSeries, []);
	return {
		type: 'line',
		symbol: 'none',
		cursor: 'initial',
		lineStyle: {
			color: getTokenValue('color.chart.success', akColors.G400),
		},
		markLine: shouldRenderTodayLine(burnup, now, maxDate)
			? {
					lineStyle: {
						color: akColors.N50,
						type: 'dashed',
					},
					silent: true,
					symbol: 'none',
					label: { color: akColors.N100, formatter: 'Today' },
					data: [{ xAxis: now.getTime() }],
				}
			: null,
		data,
		z: 3,
	};
};

export default getCompletedWorkSeries;
